import { Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-phone-number',
  templateUrl: './input-phone-number.component.html',
  styleUrls: ['./input-phone-number.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPhoneNumberComponent),
      multi: true
    }
  ]
})
export class InputPhoneNumberComponent extends FormComponentControl implements OnInit {
  @Input() groupClass = 'mb-3';
  @Input() labelClass = 'mb-1';
  @Input() inputClass = '';
  @Input() iconClass: 'icon-iphone';
  @Input() isDisabled: boolean;
  @Input() numberOnly: boolean;
  @Input() maxlength: string;
  @Input() errors = inputMgsErrs.mobilePhone;
  @Input() inputText = '';

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
  ) {
    super(cc);
  }

  ngOnInit() {
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.browserIE = true;
    }
    this.checkInitialControl();
  }

  onBlur() {
    this._isFocus = false;
    this._isBlur = true;
  }
}

